import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LineCheckCircleIcon from 'LuxKit/Icons/line/LineCheckCircleIcon'

const validityIcon = <LineCheckCircleIcon colour="success" size="S" />

interface Props {
  provider?: App.ExperienceOffer['provider']
  className?: string
}

function ExperienceCollinsonValidityNote({ provider, className }: Props) {
  const intl = useIntl()

  if (provider !== 'cln') return null

  return <BodyTextBlock variant="medium" startIcon={validityIcon} className={className}>
    {intl.formatMessage({
      id: 'EmENifCHWIuwd5PYzMli',
      defaultMessage: 'Valid for 12 months from the selected date · Date cannot be changed.',
      description: 'Validity note for Collinson lounge passes after the customer selects a lounge access date',
    })}
  </BodyTextBlock>
}

export default ExperienceCollinsonValidityNote
